import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import { CommonConfig } from '../../configs/config.common';
import Intro from './Intro/intro.vue';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { AxiosPromise } from '../../utils/axios.promise';
import * as T_T from 'cryface';
import { makeId } from '../../utils/common.util';

@Component({
    components: {
        Header,
        SpinLoader,
        NavSide,
        Intro,
        ASpaceInBetweenAnother,
    }
})
export default class FrontstoreSettingPage extends Vue {
    public title: string = 'FrontstoreSettingPage';

    public configs = new CommonConfig();

    public isLoading = false;

    public storeBannersPreset: string[] = [];

    public userRefId = -1;

    public fields: any = {
        storeName: {
            value: '',
            state: null,
            errorMsg: '请检查您的网站名称长度，5-20个字',
        },
        storeTemplate: {
            value: '',
            state: null,
        },
        storeDomain: {
            value: makeId(8),
            state: null,
            errorMsg: '域名不能为空, 至少两个字符'
        },
        storeBanner: {
            value: new CommonConfig().storeBannerPlaceHolder,
            state: null,
        },
    };

    public async created() {
        this.$store.commit('selectSection', '9');
    }

    public async handleSubmit(evt: any) {
        evt.preventDefault();
        if (this.fields.storeName.state
            && this.fields.storeDomain.state
            && this.fields.storeBanner.state) {
            this.isLoading = true;
            const body = {
                xwebsiteTitle: this.fields.storeName.value,
                xbanerUrl: this.fields.storeBanner.value,
                xdomain: `${this.fields.storeDomain.value}${this.configs.storeAddress}`,
                userId: this.userRefId,
                ltype: 0,
            };
            const submitFormPost = await AxiosPromise.postUrlEncode(`${this.configs.cimsServHost}/resPartner/updateStoreByUserId`, body);
            if (submitFormPost.data.code === 200) {
                alert('设置成功');
            }
            this.isLoading = false;
        } else {
        }
    }

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onAuthenticated(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            this.isLoading = true;
            await this.getItems();
            const id: number = val.id;
            this.fields.storeName.value = `${val.partner.name}的网站`;
            if (T_T.simpleDetect(id)) {
                this.getStoreInfo(id, val.partner.name);
            }
            this.isLoading = false;
        }
    }

    public async getStoreInfo(id: number, userName: string) {
        const body = {
            ltype: 0,
            yhId: id
        };
        const apiHost = this.configs.cimsServHost;
        const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/resPartner/storeInfo`, body);
        if (fetched.data.code === 200) {
            if (T_T.simpleDetect(fetched.data.data)) {
                const storeInfo = fetched.data.data;
                this.fields.storeBanner.value = T_T.simpleDetect(storeInfo.xbannerUrl) ? storeInfo.xbannerUrl : this.fields.storeBanner.value;
                this.fields.storeDomain.value = T_T.simpleDetect(storeInfo.xdomain) ? storeInfo.xdomain.replace(this.configs.storeAddress, '')
                    : `${userName.replace(' ', '').toLowerCase()}`;
                this.fields.storeName.value = T_T.simpleDetect(storeInfo.xwebsiteTitle) ? storeInfo.xwebsiteTitle : `${userName}的网站`;
                this.userRefId = storeInfo.userRefId;
            }
        }
    }

    public async previewStore() {
        const agentUrl = `${this.configs.storeProtocol}${this.fields.storeDomain.value}${this.configs.storeAddress}`;
        window.open(agentUrl);
    }

    public async getItems() {
        const body = {
            ltype: 0,
            pageNum: 1,
            pageSize: 20
        };
        const apiHost = this.configs.cimsServHost;
        const fetched = await AxiosPromise.postUrlEncode(`${apiHost}/storeTemp/getAllTemp`, body);
        if (fetched.data.code === 200) {
            this.storeBannersPreset = fetched.data.data;
            this.fields.storeBanner.value = this.storeBannersPreset[0];
        }
    }

    public selectBanner(str: string) {
        this.fields.storeBanner.value = str;
    }

    public async getRemoteUser(agentUrl: string = '') {
        const commonConfigs = new CommonConfig();
        const cmisapiHost: string = commonConfigs.cimsServHost;
        const fetched: any = await AxiosPromise.get(`${cmisapiHost}/bimsUser/getAgentProfile?agentBlogUri=${agentUrl}`);
        if (T_T.simpleDetect(fetched) && fetched.code === 200) {
            return fetched.data;
        } else {
            return 0;
        }
    }

    @Watch('fields.storeName.value', { immediate: true, deep: true })
    public onStoreNameChange(val: any, oldVal: any) {
        if (val.length > 5 && val.length < 20) {
            this.fields.storeName.state = true;
        } else {
            this.fields.storeName.state = false;
        }
    }

    @Watch('fields.storeDomain.value', { immediate: true, deep: true })
    public onStoreDomainChange(val: any, oldVal: any) {
        if (val.length > 2) {
            this.fields.storeDomain.state = true;
        } else {
            this.fields.storeDomain.state = false;
        }
    }

    @Watch('fields.storeBanner.value', { immediate: true, deep: true })
    public onStoreBannerChange(val: any, oldVal: any) {
        if (val.length > 2) {
            this.fields.storeBanner.state = true;
        } else {
            this.fields.storeBanner.state = false;
        }
    }
}
